import React from "react";

interface BuildingOfficePlusIconProps {
    className?: string;
}

export const BuildingOfficePlusIcon: React.FC<BuildingOfficePlusIconProps> = ({
    className,
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 29 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className={className}>
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
            />
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M25 7.5v3m0 0v3m0-3h3m-3 0h-3"
            />
        </svg>
    );
};
